import React, {Component} from 'react';

import BootstrapTable from 'react-bootstrap-table-next';
import {SkyLightStateless} from 'react-skylight';
import InputMask from "react-input-mask";
import paginationFactory from "react-bootstrap-table2-paginator";
import overlayFactory from 'react-bootstrap-table2-overlay';


export default class AdminTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            action: null,
            selectedItem: null
        }
    }

    // exportData = () => {
    //     const download_url = `${urls.API_ROOT}${this.props.url}`;
    //
    //     axios
    //         .post(download_url, data, tokenHeader())
    //         .then((response) => {
    //             this.setState({download: false}, () => window.location = response.data.file);
    //             this.state._notificationSystem.addNotification({
    //                 title: 'Fame & Ethanol',
    //                 children: (
    //                     <div>
    //                         <p>Su descarga ya se encuentra en proceso.</p>
    //                     </div>
    //                 ),
    //                 level: 'success',
    //                 position: 'tr',
    //                 dismissible: true
    //             });
    //         })
    //         .catch((error) => {
    //             let notification = {
    //                 title: 'Fame & Ethanol',
    //                 children: (
    //                     <div>
    //                         <p>Ha ocurrido un error inesperado. Por favor, refresque el sitio y vuelva a intenarlo.</p>
    //                     </div>
    //                 ),
    //                 level: 'error',
    //                 autoDismiss: 0,
    //                 dismissible: true,
    //                 position: 'tr',
    //             };
    //             this.state._notificationSystem.addNotification(notification);
    //         });
    // };

    openModal = () => {
        this.setState({showModal: true});
    };

    closeModal = () => {
        this.setState({showModal: false, action: null});
    };

    handleSelectChange = (ev) => {
        let target = ev.target;
        let prop = target.getAttribute('data-state-var');
        this.setState({[prop]: target.value});
    };

    actionItem = (item, action) => {
        this.setState({
            showModal: true,
            action: action,
            selectedItem: item
        });
    };

    actionColumn = (cell, item) => {
        return (
            <div className={"action-images"}>
                <i className="material-icons shell-red-text"
                   onClick={() => this.actionItem(item, 'view')}>info</i>
                <i className="material-icons shell-red-text"
                   onClick={() => this.actionItem(item, 'edit')}>edit</i>
                <i className="material-icons shell-red-text"
                   onClick={() => this.actionItem(item, 'delete')}>delete</i>
            </div>
        )
    };

    editColumn = (cell, item) => {
        return (
            <div className={"action-images"}>
                <i className="material-icons shell-red-text"
                   onClick={() => this.actionItem(item, 'view')}>info</i>
                <i className="material-icons shell-red-text"
                   onClick={() => this.actionItem(item, 'edit')}>edit</i>
            </div>
        )
    };

    render() {
        let columns = [...this.props.columns];
        columns.push({
            text: '',
            dataField: 'actions',
            formatter: this.props.deleteComponent ? this.actionColumn : this.editColumn,
            headerStyle: () => {
                return { width: 'auto'};
            },
            style: {width: 'auto', textAlign: 'right'}
        });


        let ViewComponent = this.props.viewComponent;
        let FormComponent = this.props.formComponent;
        let DeleteComponent = this.props.deleteComponent;

        let modalStyle = {
            top: '30%'
        };

        if (this.state.action && this.state.action === 'delete') {
            modalStyle = {
                top: '30%',
                width: 400,
                height: 500,
                maxHeight: 400,
                marginTop: 0,
                marginLeft: -200,
                left: '50%'
            }
        }

        return (
            <div style={{marginTop: 70, marginLeft: 180, width: '85%'}}>
                <div className={'admin-top'}>
                    <button className={'btn btn-shell-empty z-depth-0 right margin-bottom-20'}
                            onClick={() => {
                                this.setState({action: 'new', showModal: true})
                            }}
                            style={{marginTop: '5px'}}
                    >
                        {this.props.button}
                    </button>
                    {this.props.user &&
                    <div className={'admin-table-filters'}>
                        <div className={"col s3 input-field"}>
                            <label className="active">Nombre</label>
                            <input onChange={(ev) => this.props.inputAction('first_name__icontains', ev.target.value)}
                                   type="text" placeholder={'Ingrese un nombre'} value={this.props.first_name__icontains}/>
                        </div>
                        <div className={"col s3 input-field"}>
                            <label className="active">Apellido</label>
                            <input onChange={(ev) => this.props.inputAction('last_name__icontains', ev.target.value)}
                                   type="text" placeholder={'Ingrese un apellido'} value={this.props.last_name__icontains}/>
                        </div>
                    </div>}
                </div>
                <BootstrapTable
                    remote
                    keyField={'id'}
                    bordered={false}
                    classes={'striped highlight bordered custom-black-table admin-table'}
                    data={this.props.data}
                    pagination={this.props.pagination}
                    onTableChange={this.props.onTableChange}
                    columns={columns}
                    noDataIndication={() => {
                        return <p className={"center"}>No hay información disponible</p>
                    }}
                    loading={this.props.xhr}
                    overlay={overlayFactory({
                        spinner: true,
                        background: 'rgba(192,192,192,0.85)',
                        text: 'Cargando usuarios...',
                        className: this.props.user && this.props.xhr && 'admin-overlay'
                    })}
                />
                <button className={'btn btn-shell-empty z-depth-0 right margin-top-20 hide'}
                        onClick={() => {
                        }}
                >
                    Exportar listado
                </button>
                <SkyLightStateless
                    onOverlayClicked={this.closeModal}
                    isVisible={this.state.showModal}
                    onCloseClicked={this.closeModal}
                    dialogStyles={modalStyle}
                >
                    {this.state.action && this.state.action === 'view' &&
                    <ViewComponent
                        item={this.state.selectedItem}
                        closeAction={this.closeModal}
                        editAction={this.actionItem}
                    />
                    }
                    {this.state.action && this.state.action === 'new' &&
                    <FormComponent
                        item={null}
                        closeAction={this.closeModal}
                        refreshAction={this.props.refreshAction}
                    />
                    }
                    {this.state.action && this.state.action === 'edit' &&
                    <FormComponent
                        item={this.state.selectedItem}
                        closeAction={this.closeModal}
                        refreshAction={this.props.refreshAction}
                    />
                    }
                    {this.state.action && this.state.action === 'delete' &&
                    <DeleteComponent
                        item={this.state.selectedItem}
                        closeAction={this.closeModal}
                        refreshAction={this.props.refreshAction}
                    />
                    }
                </SkyLightStateless>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/adminTable.js